import * as React from "react";
import { withStyles, WithStyles } from "@material-ui/core";
import { styles } from "../../styles/layouts/app-layout";
import TopBar from "../generic/top-bar";

/**
 * Interface describing component props
 */
interface Props extends WithStyles<typeof styles> {}

/**
 * App layout component
 * 
 * @param props component props
 */
const AppLayout: React.FC<Props> = ({ classes, children }) => {
  return (
    <div className={ classes.root }>
      <TopBar/>
      <div className={ classes.content }>
        { children }
      </div>
    </div>
  );
}

export default withStyles(styles)(AppLayout);